module.exports = __webpack_public_path__ + "44c3ae3cc991255ac847814a2fd642ef.svg";